(function () {
  function wrapSpecialCharacters() {
    const titleSelectors = [
      "h1.product-summary__title",
      ".products-list-item__bottom h3.products-list-item__title.product__title a",
      ".section-countdown-banner-left h2",
      ".section-404-content h2.section-404-content__special-heading"
    ];


    titleSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        const originalText = el.innerText;

        if (el.querySelector('.special-char')) return;

        // if (/[-&–—!]/.test(originalText)) {
        if (/[0-9\-&–—!]/.test(originalText)) {
          const newHTML = originalText.replace(/([0-9\-&–—!'`\(\)])/g, '<span class="special-char">$1</span>');

          // const newHTML = originalText.replace(/([0-9\-&–—!])/g, '<span class="special-char">$1</span>');
    // console.log(newHTML);
          el.innerHTML = newHTML;
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", wrapSpecialCharacters);
  document.addEventListener("page:loaded", wrapSpecialCharacters);

  const observer = new MutationObserver(wrapSpecialCharacters);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// header dropdown for desktop
document.addEventListener("DOMContentLoaded", function () {
    var storeSelectorResp = document.getElementById("store-selector-desk");

    if (storeSelectorResp) {
        var currentHost = window.location.hostname.trim().toLowerCase();

        // Map hosts to option text
        var hostToText = {
            "0e2j2p-pb.myshopify.com": "To UK/EU Site",
            "1vjvm0-if.myshopify.com": "To ROW Site"
        };

        for (var i = 0; i < storeSelectorResp.options.length; i++) {
            var optionHost = new URL(storeSelectorResp.options[i].value).hostname.trim().toLowerCase();

            if (currentHost === optionHost) {
                storeSelectorResp.selectedIndex = i;
                break;
            }
        }

        // Change event for redirect
        storeSelectorResp.addEventListener("change", function () {
            var url = this.value;
            if (url) {
                window.location.href = url;
            }
        });
    }
});


// header dropdown for responsive
document.addEventListener("DOMContentLoaded", function () {
    var storeSelectorResp = document.getElementById("store-selector-resp");

    if (storeSelectorResp) {
        // Prevent Shopify's auto-submit if inside a form
        if (storeSelectorResp.form) {
            storeSelectorResp.form.addEventListener("submit", function (e) {
                e.preventDefault();
            });
        }

        // Redirect instantly in same tab
        storeSelectorResp.addEventListener("change", function () {
            var url = this.value;
            if (url) {
                // window.open(url, "_blank");
                window.location.href = url;
            }
        });
    }
});





// Old code for remove demo logo from title 
// document.addEventListener("DOMContentLoaded", function () {
//     const titleSelectors = [
//       "h1.product-summary__title",
//       ".products-list-item__bottom h3.products-list-item__title.product__title a",
//       ".section-countdown-banner-left h2"
//     ];

//     titleSelectors.forEach(selector => {
//       document.querySelectorAll(selector).forEach(el => {
//         const originalText = el.innerText;

//         // Match and wrap special characters (-, &, –, —, !)
//         if (/[-&–—!]/.test(originalText)) {
//           const newHTML = originalText.replace(/([-&–—!])/g, '<span class="special-char">$1</span>');
//           el.innerHTML = newHTML;
//         }
//       });
//     });
//   });

// home slider for responsive
var swiper = new Swiper(".home-slider-resp", {
  pagination: {
    el: ".swiper-pagination",
  },
});